<template>
  <div class="zong">
    <div class="login">
      <el-form ref="form" :model="form" label-width="80px">
        <img src="/imgs/pic_logo1.png" alt="" class="login_logo" />
        <p class="login_line"></p>
        <p class="login_f2">
          邮件安全高级防护系统 <span style="font-size:14px"></span>
        </p>
        <!-- <p class="login_f2">数据泄露防护系统HS2000/V6.0 <span style="font-size:14px"></span> </p>-->
        <el-input
          placeholder="请输入用户名"
          v-model="form.username"
          name="username"
          autocomplete="value"
          clearable
        >
          ></el-input
        >
        <el-input
          placeholder="请输入密码"
          v-model="form.password"
          show-password
        ></el-input>
       
 
        <ul class="yan" v-if="this.sys_captcha_on==1">
          <el-input placeholder="请输入验证码" v-model="form.code"></el-input>
          <img
            alt
            @click="replace"
            :src="imgCode"
            width="60"
            height="34"
            class="auth_code"
          />
        </ul>
<el-checkbox v-model="checked_pword" @change="pass_check" class="el-input" style="color:#fff">记住密码</el-checkbox>
        <p class="login_line" style="margin-top:10px"></p>

        <ul class="login_footer">
          <div class="login_footer_warp">
            <div
              class="lang_ch"
              v-for="(v, i) in lange"
              :key="i"
              v-on:click="addClass(i)"
              v-bind:class="{
                ischeck: i == current,
              }"
            >
              <img :src="v.img" alt="" />
              <span>{{ v.label }}</span>
            </div>
          </div>
          <el-button type="primary" @click="onSubmit">登录</el-button>
        </ul>
      </el-form>
    </div>
    <div class="footer_page">
      <!--  <p>北京方向标信息科技有限公司</p>
        <p>京ICP备12046650号</p>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked_pword:false,
        sys_captcha_on:0,
      current: "",
      // 验证码
      imgCode: "/api/adm/cgi/captcha.cgi?",
      // 表单
      form: {
        username: "",
        password: "",
        code: "",
      },
      // 语言
      language: "" || "zh_CN",
      lange: [
        {
          img: "/imgs/pic_cn.png",
          label: "简体中文",
        },
        {
          img: "/imgs/pic_us.png",
          label: "English",
        },
      ],
    };
  },
  created() {
    let that = this;
    document.onkeydown = function(e) {
      e = window.event || e;
      // console.log(e.code)

      if (
        that.$route.path == "/login" &&
        (e.code == "Enter" || e.code == "Num Enter" || e.code == "NumpadEnter")
      ) {
        //验证在登录界面和按得键是回车键enter
        that.onSubmit(); //登录函数 （handleSubmit2('ruleForm2')-登录按钮的点击事件）
      }
    };
  },
  mounted() {
    let strName=localStorage.getItem('fang_user_name');
    let strPassword=localStorage.getItem('fang_password');

    if(strName){
      this.form.username=strName;
      this.checked_pword=true
    }
     if(strPassword){
      this.form.password=strPassword;
      this.checked_pword=true
    }
      this.first_login()
  },
  methods: {
    pass_check(val){
        console.log(val)
      if(val){
        localStorage.setItem('fang_user_name',this.form.username);
        localStorage.setItem('fang_password',this.form.password);
      }else{
        localStorage.removeItem('fang_user_name');
        localStorage.removeItem('fang_password');

      }
    },
    first_login() {
      this.$axios
        .get("/api/adm/cgi/bspam.cgi", {
          params: {
            __mode: " load_index_html",
           

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          this.sys_captcha_on=res.data.ret.SYS_CAPTCHA_ON
        });
    },
    addClass: function(index) {
      // window.location.reload()

      this.current = index;
      // console.log(index)
      if (index == 0) {
        this.language = "zh_CN";
      } else if (index == 1) {
        this.language = "en_US";
      }
      // console.log(this.language)
    },

    replace() {
      const num = Math.ceil(Math.random() * 10); // 生成一个随机数（防止缓存）
      this.imgCode = "/api/adm/cgi/captcha.cgi?" + num;
    },
    onSubmit() {
      // console.log(this.form)
      // let { username, password ,action,language} = this.form;
      let str = this.$qs.stringify({
        username: this.form.username,
        password: this.form.password,
        vcode: this.form.code,
        action: "valid_login",
        language: this.language,
      });
      if (this.form.username === "" || this.form.password === "") {
        this.$message({
          type: "error",
          message: "账号密码未输入",
        });

        // this.form.username = ""
        // this.form.password = ""
      } else if (this.form.code === "" &&this.sys_captcha_on==1) {
        this.$message({
          type: "error",
          message: "验证码未输入",
        });
      } else {
        // 调用登陆接口
        this.$axios
          .post("/api/adm/cgi/index.cgi", str)

          .then((res) => {
            console.log(res);
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              this.$message({
                type: "error",
                message: `${res.data.fmstatus.errmsg}`,
              });
            } else if (res.data.fmstatus.code == "2") {
              this.$message({
                type: "error",
                message: `${res.data.fmstatus.errmsg}`,
              });
              this.replace();
              this.form.username = "";
              this.form.password = "";
              this.form.code = "";
            } else {
              this.$store.dispatch("checkUser", res.data.ret);
              // 登录
              this.$router.push("/home");
              // alert(document.cookie)
              // this.form.username = ""
              // this.form.password = ""
              // this.form.code = ""
            }
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ischeck {
  background: #fff;
  color: #0e2c5e !important;
  font-weight: 550;
  border-radius: 2px;
}

* {
  margin: 0;
  padding: 0;
}

.zong {
  // position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // background-image: linear-gradient(-20deg, #b721ff 0%, #21d4fd 100%);

  background: url("/imgs/pic_bg.png") no-repeat;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
}

.footer_page {
  margin-top: calc(3vh);
  // position: absolute;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  // bottom: 15px;

  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #ffffff;

  p {
    margin-bottom: 5px;
  }
}

// 登录页面
.login {
  width: 36%;
  // border: 1px solid #ccc;

  // border-radius: 10px;
  // box-shadow: 1px 1px 10px rgba(5, 134, 255, 0.25);
  // border: 1px solid rgba(24, 144, 255, .45);
  display: flex;
  align-items: center;
}

// login

.login_f1 {
  padding-top: 12px;
  font-size: 22px;
  font-weight: 400;
  color: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
}

.login_f2 {
  padding-top: 12px;
  padding-bottom: 4px;
  // padding-left: 12px;

  font-size: 18px;

  font-weight: 500;
  color: #ffffff;

  font-family: PingFangSC-Medium, PingFang SC;
}

.login-top img {
  width: 200px;
  height: 40px;
  display: block;
}

.login form h1 {
  // font-family:"微软雅黑";
  // font-weight: 500;
  // font-size: 22px;
  // // margin-bottom: 10px;
  // text-transform: uppercase;
  // color: #333;
  // text-shadow: rgb(181, 245, 253) 2px 2px 2px;
}

// 验证码
.yan {
  width: 80%;
  position: relative;

  display: flex;
  align-items: center;

  .el-input {
    width: 100%;
  }

  .auth_code {
    position: absolute;
    right: 6px;
    top: 14px;
  }
}

// 语言
.language {
  width: 84%;
  display: flex;
  align-items: center;

  /deep/.el-input {
    width: 100%;
  }
}

/deep/.el-input > input {
  height: 34px;
}

// 下拉菜单
.el-select {
  width: 100%;
}

.login form {
  width: 100%;
  padding-bottom: 10px;
  background: #2a498f;

  border-radius: 15px;
  // padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .login_logo {
    width: 200px;
    // height: 38px;
    height: auto;
    margin: 12px 0;
  }

  .login_line {
    width: 100%;
    background: #fff;
    height: 1px;
    opacity: 0.4;
  }

  .login_footer {
    margin-top: 10px;
    width: 80%;
    display: flex;
    justify-content: space-between;

    .login_footer_warp {
      display: flex;

      border: 1px solid #d2d7e6;
      border-radius: 4px;
      // margin: 0;
      height: 40px;
      line-height: 40px;
    }
  }

  .lang_ch {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    margin: 5px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #ffffff;
    // margin: 4px 0;
    // height: 34px;
    // line-height: 34px;

    img {
      width: 24px;
      height: 24px;
    }

    span {
      height: 34px;
      line-height: 34px;
      margin-left: 10px;
      font-size: 14px;
    }
  }

  // p {

  //     font-size: 22px;
  //     font-family: PingFangSC-Medium, PingFang SC;
  //     font-weight: 500;
  //     line-height: 30px;
  //     height: 30px;
  //     color: #0E2C5E;
  //     margin-top: 20px;
  //     margin-bottom: 10px;
  // }
}

/deep/ .el-input > input {
  height: 40px;
}

// /deep/ .el-input__inner {
//     width: 78%;
// }

/deep/ .el-input {
  width: 80%;
}

.login form div {
  margin: 10px 0;
}

.login form button {
  margin-top: 10px;
  width: 25%;

  background: #006be7;
  border-radius: 4px;
  // margin-bottom: 20px;
}

.el-button--primary {
  border: 0;
}

/deep/ .el-button {
  height: 42px;
}
</style>
